// Email validation using comprehensive regex
export const isValidEmail = (email: string): boolean => {
  if (!email || typeof email !== 'string') return false;
  
  // Comprehensive email regex pattern
  const emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  
  // Basic length check
  if (email.length > 254) return false;
  
  // Basic format check
  if (!emailPattern.test(email)) return false;
  
  // Check for valid domain part
  const parts = email.split('@');
  if (parts.length !== 2) return false;
  
  const [localPart, domainPart] = parts;
  
  // Local part checks
  if (localPart.length === 0 || localPart.length > 64) return false;
  if (localPart.startsWith('.') || localPart.endsWith('.')) return false;
  if (localPart.includes('..')) return false;
  
  // Domain part checks
  if (domainPart.length === 0 || domainPart.length > 253) return false;
  if (domainPart.startsWith('.') || domainPart.endsWith('.')) return false;
  if (domainPart.includes('..')) return false;
  if (!domainPart.includes('.')) return false;
  
  return true;
};

// Phone number validation helper
export const isValidPhoneForCountry = (phoneNumber: string, _countryCode: string): boolean => {
  // This will be used by the PhoneNumberInput component
  const digits = phoneNumber.replace(/\D/g, '');
  
  // Basic length check - most phone numbers are between 7-15 digits
  if (digits.length < 7 || digits.length > 15) return false;
  
  // Country-specific patterns could be added here
  // For now, just basic validation
  return digits.length >= 7;
};

// Contact name validation (firstname + lastname)
export const isValidContactName = (name: string): boolean => {
  if (!name || typeof name !== 'string') return false;
  const trimmed = name.trim();
  if (trimmed.length < 2) return false;
  
  // Check if it contains at least first name and last name (two words)
  const words = trimmed.split(' ').filter(word => word.length > 0);
  if (words.length < 2) return false;
  
  // Check if each word has at least 2 characters and contains only letters, spaces, and common name characters
  const namePattern = /^[a-zA-ZàáäčďéěíňóôöřšťúůüýžÀÁÄČĎÉĚÍŇÓÔÖŘŠŤÚŮÜÝŽ\s\-\.]+$/;
  if (!namePattern.test(trimmed)) return false;
  
  // Each individual word should be at least 2 characters
  return words.every(word => word.length >= 2);
};